import { useCallback } from 'react';
import { getAuthRole } from 'shared/auth/AuthToken';
import { trackEvent } from 'shared/helpers/Analytics';
import { useCarrierInfo } from 'shared/modules/carrier-profile/data/CarrierInfoAPI';

type ChangeBankAccountEventName =
  | 'Carrier Opened Change Bank Account Slider'
  | 'Carrier Submitted Change Bank Account Verification Code'
  | 'Carrier Clicked Contact Support After Verification Locked';

export function useTrackChangeBankAccountEvent() {
  const { data: carrierInfo } = useCarrierInfo();

  return useCallback(
    (name: ChangeBankAccountEventName) => {
      trackEvent(name, {
        carrier_name: carrierInfo?.name ?? null,
        user_email: carrierInfo?.email ?? null,
        user_name: carrierInfo?.contact_name ?? null,
        user_role: getAuthRole(),
      });
    },
    [carrierInfo],
  );
}
